/**
 * Shared courier catalog for admin dropdowns. Mirrors the backend
 * `sms.COURIERS` map in /app/backend/fast2sms_service.py — keep both in sync
 * when adding a new partner.
 */
export const COURIERS = [
  { key: "shipmaxx", name: "Shipmaxx",        urlTemplate: "https://mydailybean.shipmaxx.co.in/?awb={awb}" },
  { key: "amazon",   name: "Amazon Shipping", urlTemplate: "https://track.amazon.in/tracking/{awb}" },
  { key: "envia",    name: "Envia",           urlTemplate: "https://envia.com/en-IN/tracking?label={awb}" },
  { key: "ekart",    name: "Ekart",           urlTemplate: "https://ekartlogistics.com/shipmenttrack/{awb}" },
];

export const DEFAULT_COURIER_KEY = "shipmaxx";

export function courierName(key) {
  const c = COURIERS.find((x) => x.key === (key || "").toLowerCase());
  return c ? c.name : (COURIERS.find((x) => x.key === DEFAULT_COURIER_KEY)?.name || "Courier");
}

export function trackingUrl(key, awb) {
  const c = COURIERS.find((x) => x.key === (key || "").toLowerCase())
         || COURIERS.find((x) => x.key === DEFAULT_COURIER_KEY);
  return c ? c.urlTemplate.replace("{awb}", encodeURIComponent(awb || "")) : "";
}
